import React from 'react';
import PropTypes from 'prop-types';

const BackArrowSvg = ({ status, className = '', ...props }) => {

    function getFillColor(status) {
        switch (status) {
            case 'is-not-started': return "#fafbfc";
            case 'is-skipped': return "#e9eaec";
            case 'is-completed': return "#ecf7ed";
            default: return "#f0f3f6";
        }
    }

    function getBorderColor(status) {
        switch (status) {
            case 'is-not-started': return "#e8ebef";
            case 'is-skipped': return "#DEE3E8";
            case 'is-completed': return "#a8d9ad";
            default: return "#90a5c1";
        }
    }

    return <svg viewBox="0 0 11 32" xmlns="http://www.w3.org/2000/svg"
    fill={getFillColor(status)}
        stroke={getBorderColor(status)}
        className={className}
        {...props}>
            
        <path d="M10.3888 0.346252H2.00197C0.9822 0.346252 0.339916 1.44447 0.839873 2.33327L8.35449 15.3462C8.58275 15.752 8.58275 16.2476 8.35449 16.6535L0.83986 29.6666C0.339908 30.5554 0.982193 31.6536 2.00196 31.6536H10.3888" />
    </svg>
};

BackArrowSvg.propTypes = {
    fill: PropTypes.string,
    stroke: PropTypes.string,
    className: PropTypes.string,
    status: PropTypes.string,
};

export default BackArrowSvg;